module.exports = __webpack_public_path__ + "img/logo-large.d8a07912.png";